import './promo-bar.css';
import Slider from '../slider/slider';

export default (element, data) => {
  const init = () => {
    const el = element.querySelector('[data-rotating-banner]');
    const sustainability = document.querySelector('.promo-bar__sustainability');
    const dropdown = document.querySelector('.dropdown-sustainability');
    const overlay = document.querySelector('.dropdown-sustainability__overlay');
    if (sustainability) {
      sustainability.onmouseover = () => {
        if (dropdown) {
          dropdown.classList.remove('hidden');
          overlay.classList.add('overlay-active');
          dropdown.addEventListener('mouseleave', (e) => {
            dropdown.classList.add('hidden');
            overlay.classList.remove('overlay-active');
          });
        }
      };
    }
    let slider = new Slider({
      el,
      options: {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: data.autoplaySpeed * 1000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    });
  };

  init();
};
